import type { ImgHTMLAttributes } from "react";
import images from "@/lib/responsive-images.json";

type ImageEntry = { width: number; height: number; variants: (string | number)[][] };
const catalog: Record<string, ImageEntry> = images;

// A real <img> in server HTML: SEO, native lazy loading and no hydration-dependent download.
export function ResponsiveImage({
  src,
  sizes,
  width,
  height,
  ...props
}: ImgHTMLAttributes<HTMLImageElement>) {
  const entry = src ? catalog[src] : undefined;
  if (!entry) return <img src={src} sizes={sizes} width={width} height={height} {...props} />;
  const fallback = entry.variants.find(([w]) => Number(w) >= 640) ?? entry.variants.at(-1)!;
  return (
    <img
      decoding="async"
      {...props}
      src={String(fallback[1])}
      srcSet={entry.variants.map(([w, url]) => `${url} ${w}w`).join(", ")}
      sizes={sizes ?? "(max-width: 639px) 90vw, (max-width: 1023px) 46vw, 420px"}
      width={entry.width}
      height={entry.height}
    />
  );
}
